module.exports = __webpack_public_path__ + "static/img/service-sample-white.03b2cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/service-sample-white.png
// module id = 8/D2
// module chunks = 1